import { ProductSource, WhiteLabelSetupConfiguration } from "../data-models/wl-account-setup/wl-config-data.model";

export interface IWhiteLabelSetupConfigurationApiResponse {
  name: string;
  slug: string;
  logo: string;
  show_prices: boolean;
  pdf_template: string;
  two_step_registration: boolean;
  login_background: string;
  contact_page_visibile: boolean;
  domain: string;
  qr_code_template_url: string;
  configurator_inactive_choices_visible?: boolean;
  /** Present only for white labels that have the extra product information feature. */
  extra_product_information_enabled?: boolean;
  product_source?: string;
}

export class WhiteLabelSetupConfigurationFactory {

  public createFromBackendApi(apiResponse: IWhiteLabelSetupConfigurationApiResponse): WhiteLabelSetupConfiguration {
    const configuratorInactiveChoicesVisible: boolean = typeof apiResponse.configurator_inactive_choices_visible === "boolean"
      ? apiResponse.configurator_inactive_choices_visible
      : false;
    const productSource: ProductSource = Object.values(ProductSource).find((source) => source === apiResponse.product_source)
      ?? ProductSource.Prod;

    return new WhiteLabelSetupConfiguration(
      apiResponse.name,
      apiResponse.slug,
      apiResponse.logo,
      apiResponse.show_prices,
      apiResponse.pdf_template,
      apiResponse.two_step_registration,
      apiResponse.login_background,
      apiResponse.contact_page_visibile,
      apiResponse.domain,
      apiResponse.qr_code_template_url,
      configuratorInactiveChoicesVisible,
      typeof apiResponse.extra_product_information_enabled === "boolean"
        ? apiResponse.extra_product_information_enabled
        : undefined,
      productSource
    );
  }
}
